import styles from './index.module.less';
import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import { IconFont } from '@/components';

type Props = React.PropsWithChildren<{
  btnText?: string;
  imgSrc?: string;
  describe?: string;
  subDescribe?: string;
  btnClick?: (e: React.MouseEvent) => void;
  buttonProps?: ButtonProps;
  hasBtn?: boolean;
  iconSize?: number;
  btnRender?: () => JSX.Element | undefined | boolean;
  [propName: string]: any;
}>;
const CustomEmpty: React.FC<Props> = (props: Props) => {
  const {
    btnText,
    describe,
    subDescribe,
    buttonProps,
    hasBtn = false,
    iconSize = 60,
    btnRender,
    describeStyle = {},
    subDescribeStyle = {},
    imgStyle = {},
    imgSrc,
  } = props;
  return (
    <div className={styles.custom_empty}>
      <div>
        {!imgSrc && (
          <IconFont
            type="icon-kong"
            className={styles.icon}
            style={{ fontSize: `${iconSize}px` }}
          />
        )}
        {imgSrc && <img src={imgSrc} style={{ ...imgStyle }} />}
      </div>
      <div style={{ ...describeStyle }} className={styles.describe}>
        {describe || '暂无数据'}
      </div>
      {subDescribe && (
        <div className={styles.sub_describe} style={{ ...subDescribeStyle }}>
          {subDescribe}
        </div>
      )}
      {hasBtn && (
        <div className={styles.btn}>
          <Button onClick={props?.btnClick} type="primary" {...buttonProps}>
            {btnText || '确定'}
          </Button>
        </div>
      )}
      {btnRender?.()}
    </div>
  );
};

export default CustomEmpty;
